var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", { staticClass: "inline-flex rounded-md shadow-sm" }, [
    !_vm.href
      ? _c(
          "button",
          {
            staticClass:
              "inline-flex justify-center items-center w-full px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white focus:outline-none transition ease-in-out duration-150",
            class: _vm.classes,
            attrs: { type: _vm.type },
          },
          [_vm._t("default")],
          2
        )
      : _c(
          "a",
          {
            staticClass:
              "inline-flex justify-center items-center w-full px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white focus:outline-none transition ease-in-out duration-150",
            class: _vm.classes,
            attrs: { href: _vm.href },
          },
          [_vm._t("default")],
          2
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }